import React, { useState } from "react";
import axios from "axios";
import Notification, { showToast } from "../../../../components/common/notification/Notification";
import { Col, Container, Row, Form, Button, Spinner } from "react-bootstrap";
import SingleDetailHeader from "../../../components/singleDetail/SingleDetailHeader";
import BreadCrumb from "../../../components/breadcrumb/BreadCrumb";

const UploadLeads = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 5 * 1024 * 1024) {
      showToast(
        `File size (${(selectedFile.size / (1024 * 1024)).toFixed(2)} MB) exceeds the 5 MB limit.`,
        { type: "error" }
      );
      e.target.value = null;
      setFile(null);
      return;
    }
    setFile(selectedFile);
  }; 

  const handleUpload = async () => {
    if (!file) {
      showToast("Please select a file first.", { type: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    // Debug
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }

    try {
      const response = await axios.post(`${baseUrl}/all/import/lead`, formData);
      showToast("File uploaded successfully!", { type: "success" });
      console.log(response);
    } catch (error) {
      showToast("Upload failed. Please try again.", { type: "error" });
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  
  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Upload Leads", link: "", active: true },
  ];
  return (
    <Container >
      <Notification />
      <BreadCrumb items={breadcrumbItems} />

      <Row>
        <Col lg={12} md={12} sm={12}>
          <SingleDetailHeader
            header=" Upload Leads"
            description="Upload an Excel file (.xls or .xlsx) containing lead information."
          />

          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Select Excel File (.xls / .xlsx)</Form.Label>
            <Form.Control
              type="file"
              accept=".xls,.xlsx"
              onChange={handleFileChange}
            />
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button
              variant="primary"
              onClick={handleUpload}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    className="me-2"
                  />
                  Uploading...
                </>
              ) : (
                "Upload"
              )}
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default UploadLeads;
